import "./style.scss";
import Icon from "@ant-design/icons";
import IconImage from "../../../constants/Icons";
import dayjs from "dayjs";
import { toMoneyString } from "../../../utils/fnUtil";

/* コンテンツ売上実績のカード */

const SalesContentsResultCard = ({ data, type }) => {
  const getJsxIcon = (after, before) => {
    before = Number(before);
    after = Number(after);
    let icon = "";
    if (before < after) icon = IconImage.ImageIcon1;
    if (before === after) icon = IconImage.ImageIcon2;
    if (before > after) icon = IconImage.ImageIcon3;
    return (
      <Icon component={icon} style={{ fontSize: 16, cursor: "initial" }} className="display-icon" />
    );
  };
  const getGap = (after, before, preffix = '') => {
    before = Number(before);
    after = Number(after);
    if (before === after) return '';
    if(after - before > 0) return `${preffix}${toMoneyString(after - before)}`;
    else return `- ${preffix}${toMoneyString(Math.abs(after - before))}`;
  };
  return (
    <div className="salesContentsResultCard-card">
      <table>
        <tr className="salesContentsResultCard-main-table">
          <td className="salesContentsResultCard-term">
            <span style={{ fontWeight: "bold", fontSize: 14 }}>
              {type === "daily" ? "DAILY" : type === "monthly" ? "MONTHLY" : ""}
            </span>
            <span style={{ fontSize: 10, marginLeft: 5 }}>
              {type === "daily"
                ? "前々日対比"
                : type === "monthly"
                ? "前月同期間対比"
                : ""}
            </span>
            <div style={{ fontSize: 10, color: "#7B7B7B" }}>
              {type === "daily" && data?.latest_date
                ? dayjs(data?.latest_date).format("YYYY.MM.DD")
                : type === "monthly" && data?.start_date && data?.end_date
                ? `${dayjs(data?.start_date).format("YYYY.MM.DD")}-${dayjs(
                    data?.end_date
                  ).format("YYYY.MM.DD")}`
                : "-"}
            </div>
          </td>
          <td className="salesContentsResultCard-result">
            ¥ {data?.sales_amount ? toMoneyString(data?.sales_amount) : "-"}
          </td>
          <td className="salesContentsResultCard-image">
            {type === "daily" &&
            data?.sales_amount &&
            data?.daybefore_sales_amount
              ? getJsxIcon(data?.sales_amount, data?.daybefore_sales_amount)
              : type === "monthly" &&
                data?.sales_amount &&
                data?.lastmonth_sales_amount
              ? getJsxIcon(data?.sales_amount, data?.lastmonth_sales_amount)
              : "-"}
          </td>
          <td className="salesContentsResultCard-diff">
            {type === "daily" &&
            data?.sales_amount &&
            data?.daybefore_sales_amount
              ? getGap(data?.sales_amount, data?.daybefore_sales_amount, '¥')
              : type === "monthly" &&
                data?.sales_amount &&
                data?.lastmonth_sales_amount
              ? getGap(data?.sales_amount, data?.lastmonth_sales_amount, '¥')
              : "-"}
          </td>
        </tr>
      </table>
      <table className="salesContentsResultCard-analyze-table">
        <tr>
          <td className="salesContentsResultCard-colum">
            <span>PV</span>
          </td>
          <td className="salesContentsResultCard-value">
            <span>{data?.pv_count ? toMoneyString(data?.pv_count) : "-"}</span>
          </td>
          <td className="salesContentsResultCard-image">
            {type === "daily" && data?.pv_count && data?.daybefore_pv_count
              ? getJsxIcon(data?.pv_count, data?.daybefore_pv_count)
              : type === "monthly" && data?.pv_count && data?.lastmonth_pv_count
              ? getJsxIcon(data?.pv_count, data?.lastmonth_pv_count)
              : "-"}
          </td>
          <td className="salesContentsResultCard-diff">
            <span>
              {type === "daily" && data?.pv_count && data?.daybefore_pv_count
                ? getGap(data?.pv_count, data?.daybefore_pv_count)
                : type === "monthly" &&
                  data?.pv_count &&
                  data?.lastmonth_pv_count
                ? getGap(data?.pv_count, data?.lastmonth_pv_count)
                : "-"}
            </span>
          </td>
        </tr>
        <tr>
          <td className="salesContentsResultCard-colum">
            <span>いいね</span>
          </td>
          <td className="salesContentsResultCard-value">
            <span>
              {data?.like_count ? toMoneyString(data?.like_count) : "-"}
            </span>
          </td>
          <td className="salesContentsResultCard-image">
            {type === "daily" && data?.like_count && data?.daybefore_like_count
              ? getJsxIcon(data?.like_count, data?.daybefore_like_count)
              : type === "monthly" &&
                data?.like_count &&
                data?.lastmonth_like_count
              ? getJsxIcon(data?.like_count, data?.lastmonth_like_count)
              : "-"}
          </td>
          <td className="salesContentsResultCard-diff">
            <span>
              {type === "daily" &&
              data?.like_count &&
              data?.daybefore_like_count
                ? getGap(data?.like_count, data?.daybefore_like_count)
                : type === "monthly" &&
                  data?.like_count &&
                  data?.lastmonth_like_count
                ? getGap(data?.like_count, data?.lastmonth_like_count)
                : "-"}
            </span>
          </td>
        </tr>
        <tr>
          <td className="salesContentsResultCard-colum">
            <span>投稿数</span>
          </td>
          <td className="salesContentsResultCard-value">
            <span>
              {data?.post_count ? toMoneyString(data?.post_count) : "-"}
            </span>
          </td>
          <td className="salesContentsResultCard-image">
            {type === "daily" && data?.post_count && data?.daybefore_post_count
              ? getJsxIcon(data?.post_count, data?.daybefore_post_count)
              : type === "monthly" &&
                data?.post_count &&
                data?.lastmonth_post_count
              ? getJsxIcon(data?.post_count, data?.lastmonth_post_count)
              : "-"}
          </td>
          <td className="salesContentsResultCard-diff">
            <span>
              {type === "daily" &&
              data?.post_count &&
              data?.daybefore_post_count
                ? getGap(data?.post_count, data?.daybefore_post_count)
                : type === "monthly" &&
                  data?.post_count &&
                  data?.lastmonth_post_count
                ? getGap(data?.post_count, data?.lastmonth_post_count)
                : "-"}
            </span>
          </td>
        </tr>
        <tr>
          <td className="salesContentsResultCard-colum">
            <span>1投稿最高売上</span>
          </td>
          <td className="salesContentsResultCard-value">
            <span>
              ¥ {data?.max_sales ? toMoneyString(data?.max_sales) : "-"}
            </span>
          </td>
          <td className="salesContentsResultCard-image">
            {type === "daily" && data?.max_sales && data?.daybefore_max_sales
              ? getJsxIcon(data?.max_sales, data?.daybefore_max_sales)
              : type === "monthly" &&
                data?.max_sales &&
                data?.lastmonth_max_sales
              ? getJsxIcon(data?.max_sales, data?.lastmonth_max_sales)
              : "-"}
          </td>
          <td className="salesContentsResultCard-diff">
            <span>
              {type === "daily" && data?.max_sales && data?.daybefore_max_sales
                ? getGap(data?.max_sales, data?.daybefore_max_sales, '¥')
                : type === "monthly" &&
                  data?.max_sales &&
                  data?.lastmonth_max_sales
                ? getGap(data?.max_sales, data?.lastmonth_max_sales, '¥')
                : "-"}
            </span>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default SalesContentsResultCard;
